import React, { useState } from 'react';
import '../src/i18n';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { SettingsProvider } from './context/SettingsContext';
import ProtectedRoute from './components/ProtectedRoute';
import DashboardPage from './pages/DashboardPage';
import CategoryPage from './pages/CategoryPage';
import LoginPage from './pages/LoginPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import UserManagementPage from './pages/admin/UserManagementPage';
import SalesStatisticsPage from './pages/admin/SalesStatisticsPage';
import ProductManagementPage from './pages/admin/ProductManagementPage';
import CategoryManagementPage from './pages/admin/CategoryManagementPage';
import AccessHistoryPage from './pages/admin/AccessHistoryPage';
import EditHistoryPage from './pages/admin/EditHistoryPage';
import SystemSettingsPage from './pages/admin/SystemSettingsPage';
import Footer from './components/Footer';
import PopupManager from './components/PopupManager'; // Importar el nuevo componente

const App = () => {
  const [selectedCategory, setSelectedCategory] = useState(null);

  const handleCategorySelect = (category) => {
    setSelectedCategory(category);
  };

  const handleBackToDashboard = () => {
    setSelectedCategory(null);
  };

  return (
    <AuthProvider>
      <SettingsProvider>
        <Router>
          <div className="flex flex-col min-h-screen">
            <main className="flex-grow">
              <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route 
                  path="/" 
                  element={
                    <ProtectedRoute>
                      {selectedCategory ? (
                        <CategoryPage 
                          category={selectedCategory} 
                          onBack={handleBackToDashboard}
                        />
                      ) : (
                        <DashboardPage onCategorySelect={handleCategorySelect} />
                      )}
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/admin" 
                  element={
                    <ProtectedRoute>
                      <AdminDashboardPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/admin/users" 
                  element={
                    <ProtectedRoute>
                      <UserManagementPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/admin/sales" 
                  element={
                    <ProtectedRoute>
                      <SalesStatisticsPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/admin/products" 
                  element={
                    <ProtectedRoute>
                      <ProductManagementPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/admin/categories" 
                  element={
                    <ProtectedRoute>
                      <CategoryManagementPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/admin/access-history" 
                  element={
                    <ProtectedRoute>
                      <AccessHistoryPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/admin/edit-history" 
                  element={
                    <ProtectedRoute>
                      <EditHistoryPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/admin/settings" 
                  element={
                    <ProtectedRoute>
                      <SystemSettingsPage />
                    </ProtectedRoute>
                  } 
                />
              </Routes>
            </main>
            <Footer />
            <PopupManager /> {/* El PopupManager se renderiza siempre */}
          </div>
        </Router>
      </SettingsProvider>
    </AuthProvider>
  );
};

export default App;